import { render, staticRenderFns } from "./statistical_list.vue?vue&type=template&id=2e7bbc2e&scoped=true"
import script from "./statistical_list.vue?vue&type=script&lang=js"
export * from "./statistical_list.vue?vue&type=script&lang=js"
import style0 from "./statistical_list.vue?vue&type=style&index=0&id=2e7bbc2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7bbc2e",
  null
  
)

export default component.exports